export const showAvailabilityFilter = (
  aggregations,
): { show: boolean; showNow: boolean } => {
  const availableNowBucket = (
    aggregations?.is_available_now?.buckets ?? []
  ).find((bucket) => bucket.key === 'T');
  const availableTodayBucket = (
    aggregations?.is_available_today.buckets?.buckets ?? []
  ).find((bucket) => bucket.key === 'T');
  const isNowAvailable =
    !!availableNowBucket && (availableNowBucket?.doc_count ?? 0) > 0;
  const isTodayAvailable =
    !!availableTodayBucket && (availableTodayBucket?.doc_count ?? 0) > 0;

  return {
    show: isNowAvailable || isTodayAvailable,
    showNow: isNowAvailable,
  };
};
